module.exports = __webpack_public_path__ + "img/files-empty.e4508a38.svg";